"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Button/index.tsx
var Button_exports = {};
__export(Button_exports, {
  Button: () => Button,
  ButtonShape: () => ButtonShape,
  ButtonSize: () => ButtonSize,
  ButtonVariant: () => ButtonVariant
});
module.exports = __toCommonJS(Button_exports);
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var ButtonShape = /* @__PURE__ */ ((ButtonShape2) => {
  ButtonShape2["Round"] = "round";
  ButtonShape2["Rectangle"] = "rectangle";
  return ButtonShape2;
})(ButtonShape || {});
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["Default"] = "default";
  ButtonVariant2["Primary"] = "primary";
  ButtonVariant2["Secondary"] = "secondary";
  ButtonVariant2["SecondaryWhite"] = "secondary-white";
  ButtonVariant2["Danger"] = "danger";
  ButtonVariant2["DangerWhite"] = "danger-white";
  ButtonVariant2["Info"] = "info";
  ButtonVariant2["Disabled"] = "disabled";
  ButtonVariant2["Blue"] = "blue";
  ButtonVariant2["Magenta"] = "magenta";
  ButtonVariant2["Icon"] = "icon";
  ButtonVariant2["Rounded"] = "rounded";
  return ButtonVariant2;
})(ButtonVariant || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["Small"] = "sm";
  ButtonSize2["Medium"] = "md";
  ButtonSize2["Large"] = "lg";
  ButtonSize2["ExtraLarge"] = "xl";
  return ButtonSize2;
})(ButtonSize || {});
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}
